<template>
  <anchor-modal
    v-model="display"
    width="600"
    :title="title"
    light
    header-color="white"
    :header-split="true"
  >
    <roles-form
      v-if="display"
      ref="form"
      @cancel="() => display = false"
      @success="successHandler"
    />
  </anchor-modal>
</template>

<script>
import RolesForm from './RolesForm';


export default {
  name: 'AdminRolesModalForm',
  components: {
    RolesForm,
  },
  data: () => ({
    display: false,
    title: '',
  }),
  methods: {
    open(role) {
      this.display = true;
      this.title = role ? 'Edit Role Groups' : 'Add New Role';
      this.$nextTick(() => {
        this.$refs.form.setModel(role);
      });
    },
    successHandler() {
      this.$emit('success');
      this.display = false;
    },
  },
};
</script>
